export default "__VITE_ASSET__DptBm2pe__"